import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DriversReportErrorChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.errors",
		title: "Total Errors",
		yAxisLabel: "Errors (Count)"
	} ),

	computed: {
		barData() {
			if ( this.item ) {
				return [
					this.item.stats.errors,
					this.averageValue
				];
			}

			return this.items.map( item => item.stats.errors );
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};

